import { isNumeric } from '../../util/helpers';
import { parseLatLon } from '../../airport/util/parseUtils';
import { BusinessFinderResult } from './business-finder-result.model';

/**
 * Tag name marking an FBO that offers self-serve fuel.
 */
export const FBO_SELF_SERVE_FUEL_TAG = 'Fuel::Self Serve';

/**
 * An FBO ("Business Finder") search result returned by the AirportsAPI `~/fbos` endpoint. An FBO is a
 * business carrying the `Admin::BusinessIsFbo` tag, mirroring the iOS app's FBO classification. Mirrors
 * {@link FlyingClubResult}'s `static parse` convention.
 */
export class FboResult extends BusinessFinderResult {

  /**
   * Fuel types available (from the BusinessFuel table), e.g. ["100LL", "Jet-A"]. Used for the "Fuel Type"
   * facet (matched against these rather than tags) and shown on the card.
   */
  fuelTypes: string[];

  /**
   * True when the FBO offers self-serve fuel (Fuel::Self Serve).
   */
  selfServeFuel: boolean;

  /**
   * Thumbnail image for the results card (FBO logo or first photo). Null when it has no photo.
   */
  thumbnailPhotoPath: string;

  static parse(data: any): FboResult {
    const tags: string[] = (data.tags || []).map(d => d);
    return Object.assign(new FboResult(), {
      businessId: data.businessId,
      name: data.name || null,
      city: data.city || null,
      stateProvince: data.stateProvince || null,
      latitude: isNumeric(data.latitude) ? +data.latitude : null,
      longitude: isNumeric(data.longitude) ? +data.longitude : null,
      location: (isNumeric(data.latitude) && isNumeric(data.longitude))
        ? parseLatLon(data.latitude, data.longitude) : null,
      phone1: data.phone1 || null,
      webAddress: data.webAddress || null,
      emailAddress: data.emailAddress || null,
      description: data.description || null,
      distance: isNumeric(data.distance) ? +data.distance : null,
      airportIdent: data.airportIdent || null,
      airportName: data.airportName || null,
      tags: tags,
      fuelTypes: (data.fuelTypes || []).map(d => d),
      selfServeFuel: tags.indexOf(FBO_SELF_SERVE_FUEL_TAG) !== -1,
      thumbnailPhotoPath: data.thumbnailPhotoPath || null
    });
  }
}
